{
  "pages": {
    "dashboard": {
      "hello": "Hello,",
      "userFallback": "there",
      "welcomeAgain": "Welcome again, {{userName}}!",
      "actions": {
        "manage": "Manage",
        "refresh": "Refresh"
      }
    }
  },
  "views": {
    "dashboardView": {
      "greeting": "Hello,",
      "taskCount_one": "{{count}} Task",
      "taskCount_other": "{{count}} Tasks",
      "noActiveTasksForOrganizations": {
        "title": "No active tasks for organizations",
        "description": "Add task for an organization to see it here"
      }
    }
  },
  "components": {
    "dashboard": {
      "pinMenu": {
        "pin": "Pin to dashboard",
        "unpin": "Unpin from dashboard",
        "notifications": {
          "pinSuccess": "{{name}} was successfully pinned to dashboard",
          "unpinSuccess": "{{name}} was successfully unpinned from dashboard",
          "error": "Failed to update dashboard pin preferences."
        }
      },
      "pinnedSection": {
        "title": "My pinned",
        "tabs": {
          "organizations": "Organizations",
          "teams": "Teams",
          "projects": "Projects",
          "vendors": "Vendors"
        },
        "teamsTable": {
          "columns": {
            "name": "Name",
            "activeTaskCount": "Active tasks",
            "allTaskCount": "All tasks",
            "userCount": "Users"
          },
          "noData": {
            "title": "No pinned teams",
            "description": "Pin a team from the projects menu to see it here."
          }
        },
        "columns": {
          "name": "Name"
        },
        "rowActions": {
          "label": "Pinned item actions"
        },
        "emptyState": {
          "organization": {
            "title": "No pinned organizations",
            "description": "Pin an organization from its details page to see it here."
          },
          "project": {
            "title": "No pinned projects",
            "description": "Pin a project from its details page to see it here."
          },
          "vendor": {
            "title": "No pinned vendors",
            "description": "Pin a vendor from its details page to see it here."
          },
          "team": {
            "title": "No pinned teams",
            "description": "Pin a team from the projects menu to see it here."
          }
        }
      },
      "manageModal": {
        "title": "Manage dashboard widgets",
        "subtitle": "Choose which widgets are visible and set variant layouts.",
        "variantPlaceholder": "Select variant",
        "dragHandle": "Drag widget to reorder",
        "sectionDragHandle": "Drag section to reorder",
        "saveLabel": "Save preferences",
        "notifications": {
          "success": "Dashboard preferences saved successfully.",
          "error": "Failed to save dashboard preferences."
        },
        "variants": {
          "basic": "Basic",
          "edited": "Last edited",
          "advanced": "Advanced"
        }
      },
      "sections": {
        "myPinned": "My pinned",
        "metricsSummary": "Metrics Summary",
        "upcomingTickets": "Upcoming Tickets",
        "ticketsAndTasks": "Tickets & Tasks",
        "recentActivity": "Recent Activity",
        "recentActivityViewAll": "View all"
      },
      "widgets": {
        "common": {
          "lastEdited": "Last edited"
        },
        "openTickets": {
          "title": "Open Tickets"
        },
        "openTasks": {
          "title": "Open Tasks"
        },
        "assignedProjects": {
          "title": "Managed organizations",
          "emptyState": "No managed organizations assigned"
        },
        "notifications": {
          "title": "Notifications"
        },
        "statistics": {
          "title": "Statistics"
        },
        "myPinned": {
          "title": "My pinned"
        },
        "upcomingTickets": {
          "title": "Upcoming Tickets"
        },
        "recentActivity": {
          "title": "Recent Activity",
          "viewAction": "View",
          "columns": {
            "activity": "Activity",
            "date": "Date",
            "priority": "Priority",
            "assignedPerson": "Assigned person"
          }
        },
        "emptyTasks": {
          "title": "Congrats!",
          "description": "You have completed all your tasks",
          "actionLabel": "Create new task"
        },
        "myTasks": {
          "metrics": {
            "openTasks": "Open Tasks",
            "dueToday": "Due Today"
          }
        }
      },
      "workTabs": {
        "tabs": {
          "upcomingTickets": "Open Tickets",
          "openTasks": "Open Tasks"
        }
      }
    },
    "accountAssigned": {
      "title": "Account assigned",
      "emptyListMessage": "It looks like you don't have any accounts assigned to you yet."
    },
    "taskSortBy": {
      "dueDate": "Due Date",
      "organization": "Organization"
    },
    "savings": {
      "title": "Savings achieved",
      "all": "view all",
      "total": "Total expected lifetime savings",
      "annual": "Annual savings",
      "monthly": "Monthly savings",
      "activatedSpendAreas": "{{active}} / {{total}} active spend areas",
      "month": "month",
      "commingSoonSavings": "Detailed calculations will be available soon.",
      "noSavings": "You have no savings yet",
      "error": {
        "title": "Failed to load savings data"
      }
    },
    "team": {
      "title": "Your team",
      "chatButton": "Chat",
      "scheduleButton": "Schedule meeting",
      "role": "Client Result Manager",
      "noData": {
        "title": "You have no assigned team yet",
        "description": "You are not assigned to a team yet. Please contact SIB for more information."
      },
      "error": {
        "title": "Failed to load team data"
      }
    },
    "infoModal": {
      "title": "More about stages",
      "examples": "Examples of steps we may ask you for (they may change)",
      "spendAreas": "Spend areas in many stages",
      "description": "Each spending area can exist in multiple stages. Color labels, available on hover, indicate the number of stages in which a spending area currently exists.",
      "example": "In this example",
      "stages": {
        "mobilization": {
          "title": "Mobilization",
          "description": "Your Client Results Manager will work with you to collect necessary baseline data. For most Spend Categories, this will be a Letter of Authorization, recent vendor invoice(s),  and current vendor contract(s). Required documents can be added to the Document Repository. SIB will also work with your vendors to gather additional data to build out your current spend baseline."
        },
        "spendEstimated": {
          "title": "Analyzing Spend",
          "description": "SIB will identify savings opportunities with the Current Spend Baseline and establish a savings target."
        },
        "negotiations": {
          "title": "Negotiations",
          "description": "SIB will work directly with your vendor(s) to reduce your current spend. SIB will work to reduce rates, optimize service levels, and improve efficiencies. In many cases this stage will result in a new contract proposal. "
        },
        "savingsRealized": {
          "title": "Savings realized",
          "description": "Savings have been confirmed by the Vendor(s), and SIB presented all savings opportunities to you the client to approve or reject. SIB will implement and validate all approved savings."
        },
        "monitoringSavings": {
          "title": "Monitoring Savings",
          "description": "SIB is monitoring and optimizing your savings potential. Please remember to keep SIB informed of any organizational changes like the removing or adding of a location.  SIB will periodically offer additional savings opportunities to you for approval. "
        }
      },
      "steps": {
        "kickoffCall": {
          "title": "Kickoff call",
          "description": "Join SIB on a Kick Off Call to confirm your savings strategy"
        },
        "uploadingFiles": {
          "title": "Uploading files",
          "description": "Provide SIB with baseline data by Spend Category"
        },
        "analyzingData": {
          "title": "Analyzing Data",
          "description": "SIB is reviewing client & vendor provided data to determine savings opportunity and strategy"
        },
        "negotiationsCall": {
          "title": "Negotiations call",
          "description": "SIB is contacting your Vendors to reduce your costs"
        },
        "signingContract": {
          "title": "Signing & uploading vendor contract",
          "description": "Sign & Return vendor contract proposal(s) to SIB"
        },
        "uploadingMoreInvoices": {
          "title": "Uploading more invoices",
          "description": "SIB is collecting duplicate invoices from your vendor(s) to validate & protect savings"
        },
        "followupCalls": {
          "title": "Followup calls with SIB",
          "description": "Continue to keep SIB updated on your ever changing spend landscape"
        }
      }
    }
  }
}
